

import type { ITimeZone } from '@clickster/constant-definitions/dist-esm/types/timezone';
import { getTimeZones } from '@clickster/constant-definitions/dist-esm/functions/datetime';
import { StateCreator } from 'zustand';

export interface GeneralStore {
  timezones: ITimeZone[];
  showProfileModal: boolean;
}

export const createGeneralStore: StateCreator<GeneralStore> = (set) => ({
  /* INITIAL STATE */
  timezones: getTimeZones(),
  showProfileModal: false,
});
